/** Price rules (BR-2, BR-3). Mirrors backend `apps/core/utils/pricing.py` — keep in sync. */

/** Business thresholds. Backend equivalents live in settings.ANGADI. */
export const CARD_DISCOUNT_TAG_MIN_PCT = 40
export const SHOP_DEALS_MIN_PCT = 30
export const MAX_CART_LINE_QTY = 20

export interface Priced {
  price: number | null
  mrp: number | null
}

/** round((1 − price ÷ mrp) × 100); 0 when no price, no MRP or MRP ≤ price. */
export function discountPercent({ price, mrp }: Priced): number {
  if (price == null || mrp == null || mrp <= price || mrp <= 0) return 0
  return Math.round((1 - price / mrp) * 100)
}

/** Variant price/MRP override the product's; with no variant price, the product's apply (BR-3). */
export function effectivePrice(product: Priced, variant?: Priced | null): Priced {
  if (variant && variant.price != null) return { price: variant.price, mrp: variant.mrp }
  return { price: product.price, mrp: product.mrp }
}
